import React from 'react'
// import axios from 'axios'
// import _ from 'lodash'
// import parse from 'html-react-parser'
// import { Input, Select, Radio, Upload, message, Button } from 'antd'
import { useSelector } from 'react-redux'
// import styled from 'styled-components/macro'
// import { Icon } from '@iconify/react'
// import envelope from '@iconify/icons-mdi/envelope-outline'
// import { UploadOutlined } from '@ant-design/icons'
// import { Col } from 'styled-bootstrap-grid'
// import { RadioChangeEvent } from 'antd/lib/radio/interface'
// import { SelectValue } from 'antd/lib/select'
import { LoadingOverlay } from '../../../components/Loading/LoadingOverlay'
import { WizardNavigationWrapper, WizardNav, NavProps } from '../../../components/Wizard/WizardNav'
// import { CenteredRow, Label } from '../../../components/Page/Layout'
// import { Row } from '../../../components/Grid'
import { getHookValidationResult, isValidating, selectedHook } from '../../../features/hook/selectors'
// import { HookActions } from '../../../features/hook/actions'

// const { Option } = Select

// const StyledSelect = styled(Select)`
//   width: 300px;

//   .option-item-wrapper {
//     display: flex;
//   }

//   span.title-item {
//     white-space: nowrap;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     width: 200px;
//     display: inline-block;
//   }
// `
// const SelectWrapper = styled.div`
//   display: flex;
//   justify-content: center;
// `
// const ImgSelect = styled.img`
//   width: 36px;
//   height: 28px;
//   margin: auto 10px auto 0;
//   object-fit: contain;
// `

// const ModalHook = styled.div`
//   border: 1px solid #eee;
//   border-radius: 0.8rem !important;
//   min-height: 300px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: space-between;
//   padding: 20px;

//   .hook.title {
//     text-align: center;
//   }

//   .hook-image {
//     height: auto;
//     max-width: 300px;

//     img {
//       width: 100%;
//       height: auto;
//     }
//   }

//   .header-hook {
//     font-size: 20px;
//     margin-bottom: 1em;
//   }

//   .overlay-hook {
//     background-color: red;
//     width: 100%;
//     color: #fff;
//     padding: 4px;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//   }

//   .hook-button {
//     background-color: #629d33;
//     border-color: #5c9330;
//     width: 75% !important;
//     border: 1px solid transparent;
//     padding: 0.375rem 0.75rem;
//     font-size: 1rem;
//     line-height: 1.5;
//     border-radius: 0.25rem;
//     transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
//       box-shadow 0.15s ease-in-out;
//     text-align: center;
//     vertical-align: middle;
//     color: white !important;
//     min-height: 38px;
//   }
//   .hook-button:hover {
//     cursor: pointer;
//     text-decoration: none;
//   }
// `

// const UrlImageWrapper = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-content: center;
//   > div:first-child {
//     width: calc(100% - 130px);
//   }
//   > div:last-child {
//     display: flex;
//     align-items: flex-end;
//   }
// `

// const ButtonIcon = styled.div`
//   img {
//     width: 40px;
//     height: auto;
//   }
//   cursor: pointer;
// `

type Props = {
  close?: () => void
  addHook: () => void
} & NavProps

export const AddHookElements = ({ addHook, ...rest }: Props) => {
  // const dispatch = useDispatch()
  const hook = useSelector(selectedHook)
  const status = useSelector(getHookValidationResult)
  // const paymentTemplates = useSelector(getPaymentTemplates)
  const loading = useSelector(isValidating)

  // const [fileList, setFileList] = useState<string[]>([])

  // useEffect(() => {
  //   console.log(hook)
  // }, [hook])

  // useEffect(() => {
  //   const readMedia = async () => {
  //     const resp = await axios.get('/media')
  //     if (resp && resp.data.success) {
  //       setFileList(resp.data.data)
  //     }
  //   }

  //   readMedia()
  // }, [])

  // const changeHandler = async (field: string, e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (hook && hook.name) {
  //     const hookToValidate = { ...hook, [field]: e.target.value }
  //     dispatch(HookActions.updateNewHook(hookToValidate))
  //   }
  // }

  // const changeImagetypeHandler = async (e: RadioChangeEvent) => {
  //   const imageType = e.target.value
  //   if (hook && hook.name) {
  //     const hookToValidate = { ...hook, imageType, image: imageType === 'photo' ? 'angel.jpg' : hook.image }
  //     dispatch(HookActions.updateNewHook(hookToValidate))
  //   }
  // }

  // const changeImageUrl = (url: SelectValue | string) => {
  //   if (hook && hook.name) {
  //     const hookToValidate = { ...hook, image: `${url}` }
  //     dispatch(HookActions.updateNewHook(hookToValidate))
  //   }
  // }

  // const props = {
  //   name: 'picture',
  //   action: 'https://site-collaudo.caldetentazioni.com/api/hooks/photo',
  //   headers: {
  //     authorization: 'authorization-text'
  //   },
  //   showUploadList: false,
  //   onChange(info: any) {
  //     if (info.file.status !== 'uploading') {
  //       // console.log(info.file, info.fileList)
  //     }
  //     if (info.file.status === 'done') {
  //       message.success(`${info.file.name} file uploaded successfully`)
  //       setFileList([...fileList, info.file.name])
  //       changeImageUrl(info.file.name)
  //     } else if (info.file.status === 'error') {
  //       message.error(`${info.file.name} file upload failed.`)
  //     }
  //   },
  //   progress: {
  //     strokeColor: {
  //       '0%': '#108ee9',
  //       '100%': '#87d068'
  //     },
  //     strokeWidth: 3,
  //     format: (percent: any) => `${parseFloat(percent.toFixed(2))}%`
  //   }
  // }

  if (!hook) return null

  return (
    <LoadingOverlay loading={loading}>
      <div className="mt40">
        {/* <Row>
          <Col md={8}>
            <CenteredRow>
              Configura <strong>&nbsp;&nbsp;{hook?.name}</strong>
            </CenteredRow>
            <Row marginV={20}>
              <Col md={8} mdOffset={2} xs={12} xsOffset={0}>
                <Label>Tipo di Immagine</Label>
                <Radio.Group
                  defaultValue="icon"
                  buttonStyle="solid"
                  value={hook?.imageType}
                  onChange={(e: RadioChangeEvent) => changeImagetypeHandler(e)}
                >
                  <Radio.Button value="icon">Fissa</Radio.Button>
                  <Radio.Button value="photo">Foto profilo</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
            <Row>
              <Col md={8} mdOffset={2} xs={12} xsOffset={0}>
                <Label>Nome Immagine</Label>
                <SelectWrapper>
                  <StyledSelect
                    defaultValue="angel.jpg"
                    onChange={e => changeImageUrl(e)}
                    disabled={hook?.imageType === 'photo'}
                    value={hook?.image}
                  >
                    <Option value="angel.jpg">Nessuna</Option>
                    {_.map(fileList, (file: string, idx: number) => (
                      <Option key={`${idx}-${file}`} value={file}>
                        <div className="option-item-wrapper">
                          <ImgSelect
                            src={`http://site-collaudo.caldetentazioni.com/images/rateplans/${file}`}
                            alt={file}
                          />
                          <span className="title-item">{file}</span>
                        </div>
                      </Option>
                    ))}
                  </StyledSelect>
                  <Upload {...props}>
                    <Button>
                      <UploadOutlined /> Carica nuova
                    </Button>
                  </Upload>
                </SelectWrapper>
              </Col>
            </Row>
            <Row marginV={40}>
              <Col md={8} mdOffset={2} xs={12} xsOffset={0}>
                <Label>
                  Testo Hook <small>( permette tag HTML )</small>
                </Label>
                <Input
                  value={hook?.title}
                  placeholder="Es. Vuoi vedere i profili ?"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => changeHandler('title', e)}
                />
              </Col>
            </Row>
            <Row marginV={20}>
              <Col md={8} mdOffset={2} xs={12} xsOffset={0}>
                <Label>Testo Bottone</Label>
                <Input
                  value={hook?.button}
                  placeholder="Es. Continua"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => changeHandler('button', e)}
                />
              </Col>
            </Row>
            <Row marginV={20}>
              <Col md={8} mdOffset={2} xs={12} xsOffset={0}>
                <Label>
                  Testo Header <small>( Titolo in alto ) </small>
                </Label>
                <Input
                  value={hook?.header}
                  placeholder=""
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => changeHandler('header', e)}
                />
              </Col>
            </Row>
            <Row marginV={20}>
              <Col md={8} mdOffset={2} xs={12} xsOffset={0}>
                <Label>
                  Testo Overlay <small>( per ora è testo fisso ) </small>
                </Label>
                <Input
                  value={hook?.overlay}
                  placeholder=""
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => changeHandler('overlay', e)}
                />
              </Col>
            </Row>
          </Col>
          <Col md={4}>
            <ModalHook>
              {hook.header && <div className="header-hook">{parse(hook.header)}</div>}
              <div className="hook-image">
                <img
                  src={`http://site-collaudo.caldetentazioni.com/images/rateplans/${hook?.image}`}
                  height={100}
                  alt="hook icon"
                />
              </div>
              {hook.overlay && (
                <div className="overlay-hook">
                  <Icon icon={envelope} />
                  <span className="ml-2">1 messaggio in sospeso</span>
                </div>
              )}
              <div className="hook-title">{parse(hook.title || '')}</div>
              <div className="hook-button">{hook.button}</div>
            </ModalHook>
          </Col>
        </Row> */}

        <WizardNavigationWrapper>
          <WizardNav {...rest} nextDisabled={!status?.isValid || loading} nextStep={addHook} nextStepText="Salva" />
        </WizardNavigationWrapper>
      </div>
    </LoadingOverlay>
  )
}
